import React from 'react';
import { ENABLED_FILTERS } from '../../../../utils/constants/enable-filter-values';
import SelectCheckbox from '../../../../shared/select-checkbox';


interface ISuppliersFilters {
    selectedEnabled?: string;
    onChangeSelectedBooleanItems: (type: string, name?: string) => void;
}

const SuppliersFilters = ({
    selectedEnabled,
    onChangeSelectedBooleanItems
}: ISuppliersFilters) => {
    return (
        <div>
            <div className='mb-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4'>
                <div>
                    <SelectCheckbox
                        name={'Enabled'}
                        selectStyle={{ backgroundColor: 'transparent', borderRadius: '15px' }}
                        placeholder={' '}
                        options={ENABLED_FILTERS}
                        selectedOption={selectedEnabled}
                        uniqueName='enabled'
                        onChangeSelectedOption={onChangeSelectedBooleanItems}
                        dataQa={'retailer-enabled-filter'}
                    />
                </div>
            </div>
        </div >
    )
}

export default SuppliersFilters;